/* eslint-disable no-unused-vars */
import { Tooltip, Menu, Dropdown } from 'antd';
import DokanIcons from '../icon/DokanIcons';
import paypal from '../../assets/images/paypal.svg';

function DokanPaymentCard({ hasIcon, Icon, hasTitle, Title, hasBtn, btnTitle, children }) {
    return (
        <>
            <div className="bg-white rounded-sm mt-30px px-30px py-35px border border-primary">
                <div className="flex justify-between items-center">
                    <div className="flex gap-3 items-center">
                        <div>
                            {hasIcon && (
                                <div className="bg-white p-15px rounded-full dokan-settings-shadow">
                                    <DokanIcons icon={Icon} />
                                </div>
                            )}
                        </div>
                        {hasTitle && (
                            <div>
                                <h3 className="text-dark text-md font-bold">{Title}</h3>
                            </div>
                        )}
                    </div>
                    <div className="hidden md:block">
                        {hasBtn && (
                            <button
                                type="button"
                                className="bg-blue-payment text-white rounded-md px-20px py-10px focus:outline-none"
                            >
                                {btnTitle}
                            </button>
                        )}
                    </div>
                </div>
                <div className="pt-40px">{children}</div>
            </div>
        </>
    );
}

export default DokanPaymentCard;
